<template>
  <transition name="fade">
    <div class="alert" :class="`alert-${type}`">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    type: {
      type: String,
      default: 'success'
    }
  }
}
</script>

<style lang="scss">
.alert { padding: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/alert/Alert.vue